import FirendBaseItem from "./friend_base_item";
import Utility from "../../../../../utility/utility";



const {ccclass, property} = cc._decorator;

@ccclass
export default class FriendAddItem extends FirendBaseItem {



    onAdd(){

        Utility.playButtonSound()
        this.eventDispatch("request_add_friend");
    }

    public updateInfo(data : any){
        super.updateInfo(data);


    }
}
